import React, { PureComponent } from 'react';

// export default class OngoingIcon extends PureComponent {

//     render() {
//         const { color } = this.props
//         return (
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//             <rect x="4" y="14" width="16" height="5" rx="1" stroke={color} stroke-width="1.5"/>
//             <rect x="4" y="5" width="16" height="5" rx="1" stroke={color} stroke-width="1.5"/>
//             </svg>
//         )
//     }
// }

export default class OngoingIcon extends PureComponent {

    render() {
        const { color } = this.props
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.72498 5.25C5.86101 5.25 4.34998 6.76104 4.34998 8.625V9.975V14.025V15.375C4.34998 17.239 5.86101 18.75 7.72498 18.75H16.275C18.1389 18.75 19.65 17.239 19.65 15.375V14.025V9.975V8.625C19.65 6.76104 18.1389 5.25 16.275 5.25H7.72498ZM18.3 9.3V8.625C18.3 7.50662 17.3934 6.6 16.275 6.6H7.72498C6.6066 6.6 5.69998 7.50662 5.69998 8.625V9.3H9.67505H18.3ZM5.69998 10.65V13.35H9.00005V10.65H5.69998ZM5.69998 14.7V15.375C5.69998 16.4934 6.6066 17.4 7.72498 17.4H9.00005V14.7H5.69998ZM10.35 17.4H16.275C17.3934 17.4 18.3 16.4934 18.3 15.375V14.7H10.35V17.4ZM18.3 13.35H10.35V10.65H18.3V13.35Z" fill="#14B8A2"/>
            </svg>
        )
    }
}